import * as types from '../constants/ActionTypes';

const initialState = {
	isGlobalModalContainerOpen: false,
	modalName: '',
	componentProps: {},
};

export default function globalModal(state = initialState, action) {
	switch (action.type) {
		case types.CLOSE_GLOBAL_MODAL:
			return { ...initialState };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/global-modal.js